import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/t3.png")